import uniqBy from 'lodash/uniqBy.js';

import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class Note extends Model {
    static entity = 'notes';

    static modelName = 'Note';

    static fields() {
        return {
            id: this.attr(null),
            title: this.attr(null),
            body: this.attr(null),
            course_id: this.attr(null),
            activity_id: this.attr(null),
            created_at: this.attr(null),
            updated_at: null,
            media: this.attr(null),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
            activity: this.belongsTo('activities', 'activity_id'),
            tags: this.morphToMany('tags', 'taggables', 'tag_id', 'taggable_id', 'taggable_type'),
        };
    }

    static searchable() {
        return ['title', 'body'];
    }

    get modelName() {
        return 'Note';
    }

    get router_link() {
        return {
            name: 'note-view',
            params: { noteId: this.id },
        };
    }

    static queryBuilder(id = null) {
        const param = id ? `/${id}` : '';

        return new QueryBuilder(this.entity + param);
    }

    static async fetch(courseId = null, activityId = null) {
        let endpoint = this.queryBuilder();

        // Add includes for related models
        endpoint = endpoint.include(['course', 'activity', 'tags', 'media']);

        // Add filters based on parameters
        endpoint = courseId ? endpoint.filter('course_id', courseId) : endpoint;
        endpoint = activityId ? endpoint.filter('activity_id', activityId) : endpoint;

        const { response } = await this.api().get(endpoint.toUrl());
        return response.data;
    }

    /**
     * Deduplicate tags by id (matches Video model pattern)
     */
    uniqueTags() {
        return uniqBy(this.tags, 'id');
    }
}
